import React from "react";

/**
 * Context object used to track the current screen view size.
 * 
 * This context's value is used to store the result of the useWindowSize hook.
 */
const WindowSizeContext = React.createContext(null);

export default WindowSizeContext;